import axios from "axios";
import { API_URL_AUTH } from "../utils/Constant";

// https://uat-back.genistabio.com/api/v1/users/login/
// POST:{"email":"test@genistabio.com","password":"test@123"}
// Response: {"id":12,"email":"harshini@genistabio.com","first_name":"Harshini","last_name":"Racharla","is_staff":false,"username":"harshini@genistabio.com","token":"b6b05bd8b7de52300b612e1a8a96250fad61e56d"}
// Failed Response: {"detail":"Invalid Login Credentials.","status_code":400}
export const signIn = async (payload) => {
  try {
    const response = await axios.post(
      `${API_URL_AUTH}/users/login/`,
      {
        email: payload.email,
        password: payload.password,
      },
    );

    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: e.response?.data?.detail || "Something went wrong." };
  }
};

export const guestSignIn = () => {
  try {
    // HARDCODING: harding the guest login infomation
    const guestInfo = {
      id: -1,
      email: "guest",
      first_name: "Guest",
      last_name: "",
      is_staff: false,
      username: "guest",
      role: -1,
    };
    return { success: true, ...guestInfo };
  } catch (e) {
    return { success: false, message: e.response?.data?.detail || "Something went wrong." };
  }
};

/**
 * We use this api call to get the role id for the current user.
 * This api requires the token from the signIn api.
 * @returns return current user's information
 */
export const gerUserDetail = async () => {
  try {
    const response = await axios.get(`${API_URL_AUTH}/users/me/`);

    const data = await response.data;
    return { success: true, ...data };
  } catch (e) {
    return { success: false, message: e.response?.data?.detail || "Something went wrong." };
  }
};
